/**
 * @fileoverview CSS module for rendering group questions
 * Provides styles for group containers, layout, and spacing
 *
 * @example
 * // Usage in component:
 * import styles from './GroupRenderer.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.group}>
 *     <input className={styles.input} type="text" />
 *   </div>
 * </div>
 */

.container {
    display: flex;
    flex-direction: column;
    position: relative;
    border: 0;
    margin: 0;
    flex-grow: 1;
    padding: 0;
    gap: 16px;
}
